import { memo } from "react";
import { Box } from "@mui/material";

function CalenderIcon({ ...other }) {
  return (
    <Box {...other}>
      <svg
        width="15"
        height="14"
        viewBox="0 0 11 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.0377 0.46875C4.0377 0.208984 3.82035 0 3.5502 0C3.28004 0 3.0627 0.208984 3.0627 0.46875V1.25H2.2502C1.53316 1.25 0.950195 1.81055 0.950195 2.5V2.8125V3.75V8.75C0.950195 9.43945 1.53316 10 2.2502 10H8.7502C9.46723 10 10.0502 9.43945 10.0502 8.75V3.75V2.8125V2.5C10.0502 1.81055 9.46723 1.25 8.7502 1.25H7.9377V0.46875C7.9377 0.208984 7.72035 0 7.4502 0C7.18004 0 6.9627 0.208984 6.9627 0.46875V1.25H4.0377V0.46875ZM1.9252 3.75H9.0752V8.75C9.0752 8.92188 8.92895 9.0625 8.7502 9.0625H2.2502C2.07145 9.0625 1.9252 8.92188 1.9252 8.75V3.75Z"
          fill="#605E5C"
        />
      </svg>
    </Box>
  );
}

export default memo(CalenderIcon);
